import {Component, Input, OnInit} from '@angular/core';
import {OrderItemSelectionItem} from '../../_models/order-item-selection-item';
import {multiplyCurrency} from '../../_utils/currency-math';
import {OrderItem} from '../../_models/order-item';
import {OrderStatuses} from '../../_constants/order-statuses';

@Component({
    selector: 'bb-display-order-item-selection-item',
    templateUrl: './display-order-item-selection-item.component.html',
    styleUrls: ['./display-order-item-selection-item.component.scss']
})
export class DisplayOrderItemSelectionItemComponent implements OnInit {
    @Input() parent: OrderItem;
    @Input() selection: OrderItemSelectionItem;
    @Input() level = 1;
    @Input() compact = false;
    @Input() orderStatus: string;
    @Input() count: number;
    @Input() removePadding = false;
    @Input() hideTotal = false;

    modifierGroups = [];
    protected readonly orderStatuses = OrderStatuses;

    ngOnInit(): void {
        console.log(this.selection);
    }

    hasDetails() {
        return this.selection.orderItem.modifiers.length > 0
            || this.selection.orderItem.removedToppingsFilter().length > 0
            || this.selection.orderItem.addedToppingsFilter().length > 0
            || (!this.selection.menuSelectionItem.preventNestedSelection && this.selection.orderItem.selections.length > 0);
    }

    adjustedPrice(price) {
        return !!this.count ? multiplyCurrency(price, this.count) : price;
    }

    childRow(additionalLevel = 0) {
        return 'border-left: 1px solid #fff; margin-left: ' + ((this.level + additionalLevel + 1) * 15)
            + 'px; max-width: calc((calc(9 / var(--ion-grid-columns, 12)) * 100%) - ' + ((this.level + 1) * 15) + ')';
    }
}
